import * as ng from 'angular';
import * as _ from 'underscore';
import * as Highcharts from 'highcharts';

import {Dataset} from '..';

ng.module('e360')
   .factory('funnelChartFactory', funnelChartFactory);

funnelChartFactory.$inject = ['instanceServiceFactory'];
function funnelChartFactory(instanceServiceFactory) {
   return instanceServiceFactory(FunnelChart);
}

// Requires that object data has key value pairs
export class FunnelChart {
   static defaults = {
      'optin-funnel': {
         colors: ['#C7ECFC', '#3CB4E5', '#39329c', '#E353A9'],
         title: { text: 'Campaign Funnel' }
      }
   };

   chart:Highcharts.ChartObject;

   static $inject = ['ds'];

   constructor (ds:Dataset) {
      let defaults = FunnelChart.defaults[ds.id] || { };

      let options = _.extend({
         chart: {
            type: 'funnel',
            renderTo: ds.id
         },
         title: {
            text: null
         },
         plotOptions: {
            series: {
               width: '80%',
               center: ['40%', '50%']
            }
         }
      }, defaults);

      this.chart = new Highcharts.Chart(options);
   }

   setData(data:any[]) {
      while (this.chart.series.length > 0) {
         this.chart.series.pop().remove();
      }

      if (data.length === 0) return;

      data = data[0];

      let allZero = _.every(data, (val) => {
         return val === 0;
      });

      if (allZero) return;

      data = _.map(data, (val, key) => {
         return [key, val];
      });

      this.chart.addSeries({
         name: 'Count',
         data: data
      });
   }

   setColors(colors:string[]) {
      this.chart.options.colors = colors;
   }

   onLoadStart() {
      this.chart.showLoading();
   }

   onLoadFinish() {
      this.chart.hideLoading();
   }
}

export interface FunnelChartFactory {
   ({ds:Dataset}):FunnelChart;
}
